<template>
  <autocomplete-search
    v-model="internalValue"
    :search-function="searchPerson"
    :label="label"
    placeholder="Enter at least 5 characters to search..."
    :display-field="'Subject'"
    :value-field="'OID'"
    :subtitle-field="'BranchName'"
    :outlined="true"
    :dense="true"
    :hide-details="hideDetails"
    :dark="dark"
    @change="handleChange"
  />
</template>

<script>
import { mapActions } from 'vuex'
import AutocompleteSearch from '@/components/Tenancies/AutocompleteSearch.vue'

export default {
  name: 'PersonSearch',
  components: {
    AutocompleteSearch
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Person'
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        // If we have a value but no object, we need to handle this case
        if (newVal && !this.internalValue) {
          this.internalValue = { OID: newVal }
        } else if (!newVal) {
          this.internalValue = null
        }
      }
    }
  },
  methods: {
    ...mapActions('TenanciesManagement', ['searchEntity']),
    
    async searchPerson(searchTerm) {
      return await this.searchEntity({
        schemaType: 'ApplicationPerson',
        searchTerm
      })
    },
    
    handleChange(value) {
      // Extract just the OID for the v-model
      const personId = value ? value.OID : ''
      this.$emit('input', personId)
      this.$emit('change', personId)
      
      // Update internal value
      this.internalValue = value
    }
  }
}
</script>